<template>
    <div v-if="mounted">
        <template v-if="visualizationType === 'pojedynczy'">
            <form-layer-style-point-single-symbol v-bind:size="size" ref="singleSymbol" @updated="updateValue" @errorMessage="setError" :icon-picker-type="iconPickerType"/>
        </template>
        <template v-else-if="visualizationType === 'unikalny'">
            <form-layer-style-point-unique-value v-bind:attributes="attributes" v-bind:layer-id="layerId" v-bind:size="size" ref="uniqueValue" @updated="updateValue" @errorMessage="setError" :icon-picker-type="iconPickerType"/>
        </template>
        <template v-else-if="visualizationType === 'stopniowy'">
            <form-layer-style-point-gradual-symbol v-bind:attributes="attributes" v-bind:layer-id="layerId" v-bind:value="gradualSymbol" v-bind:size="size" ref="gradualSymbol" @updated="updateValue" @errorMessage="setError" :icon-picker-type="iconPickerType"/>
        </template>
    </div>
</template>

<script>
import FormLayerStylePointSingleSymbol from "./point/FormLayerStylePointSingleSymbol.vue";
import FormLayerStylePointUniqueValue from "./point/FormLayerStylePointUniqueValue.vue";
import FormLayerStylePointGradualSymbol from "./point/FormLayerStylePointGradualSymbol.vue";
import LayerStyleStore from "./store/LayerStyleStore";

export default {
  name: "FormLayerStylePoint",
  props: {
    visualizationType: String,
    value: Object,
    attributes: Array,
    layerId: String,
    size: String,
    iconPickerType: String
  },
  data() {
    return {
      singleSymbol: null,
      uniqueValue: null,
      gradualSymbol: null,
      mounted: false
    };
  },
  mounted() {
    let store = new LayerStyleStore();
    const initialValue = store.getPointStyle();
    if (initialValue != null && initialValue.reguly != null) {
      switch (this.visualizationType) {
        case "pojedynczy":
          store.setPointSingleSymbol(initialValue);
          break;
        case "unikalny":
          store.setPointUniqueValue(initialValue);
          break;
        case "stopniowy":
          store.setPointGradualSymbol(initialValue);
          break;
      }
    }
    this.mounted = true;
  },
  methods: {
    updateValue() {
      let store = new LayerStyleStore();
      let emitValue = null;
      switch (this.visualizationType) {
        case "pojedynczy":
          emitValue = store.getPointSingleSymbol();
          break;
        case "unikalny":
          emitValue = store.getPointUniqueValue();
          break;
        case "stopniowy":
          emitValue = store.getPointGradualSymbol();
          break;
      }
      emitValue = emitValue !== null ? emitValue : {};
      emitValue.reguly = emitValue.reguly != null ? emitValue.reguly : [];
      emitValue.typ = this.visualizationType;
      store.setPointStyle(emitValue);
      this.$emit('updated');
    },
    validate() {
      switch (this.visualizationType) {
        case "pojedynczy":
          return this.$refs.singleSymbol.validate();
        case "unikalny":
          return this.$refs.uniqueValue.validate();
        case "stopniowy":
          return this.$refs.gradualSymbol.validate();
      }
    },
    setError(args) {
      this.$emit('errorMessage', args);
    }
  },
  components: {
    FormLayerStylePointSingleSymbol,
    FormLayerStylePointUniqueValue,
    FormLayerStylePointGradualSymbol
  }
};
</script>